export default __webpack_public_path__ + "images/7Z.27b6cba.png";